import {Component, inject, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {DeviceService} from "../../../../../core/services/sim-services/device.service";
import {ThemeService} from "@services";

@Component({
	selector: "sim-show-device-registration-qr-code-dialog",
	templateUrl: "./show-device-registration-qr-code-dialog.component.html",
	styleUrl: "./show-device-registration-qr-code-dialog.component.scss",
	standalone: false,
})
export class ShowDeviceRegistrationQrCodeDialogComponent extends BasicMaterialDialog<ShowDeviceRegistrationQrCodeDialogComponent> {
	public deviceService = inject(DeviceService);
	public themeService = inject(ThemeService);

	constructor(_injector: Injector) {
		super(_injector);
	}
}
